export const getFromAndTo = (
  idKey: string
): {year: string; fromDate: string; toDate: string; facilityId: string} => {
  const stringSplit = idKey ? idKey.split('/') : '';
  const facilityId = stringSplit ? stringSplit[0] : '';
  const year = stringSplit ? stringSplit[1] : '';
  const fromDate = stringSplit
    ? stringSplit[1].includes('-')
      ? stringSplit[1].split('-')[0]
      : stringSplit[1]
    : '';
  const toDate = stringSplit
    ? stringSplit[1].includes('-')
      ? stringSplit[1].split('-')[1]
      : stringSplit[1]
    : '';

  return {year, fromDate, toDate, facilityId};
};

export const getFromAndToInData = (
  selectedYear: string,
  selectedFacility: string
): {year: string; fromDate: string; toDate: string; facilityId: string} => {
  const fromDate = selectedYear.includes('-')
    ? selectedYear.split('-')[0]
    : selectedYear;

  const toDate = selectedYear.includes('-')
    ? selectedYear.split('-')[1]
    : selectedYear;

  return {year: selectedYear, fromDate, toDate, facilityId: selectedFacility};
};

export const selectedYearFromTo = (
  selectedYear: string
): {fromDate: string; toDate: string} => {
  return {
    fromDate: selectedYear.includes('-')
      ? selectedYear.split('-')[0]
      : selectedYear,
    toDate: selectedYear.includes('-')
      ? selectedYear.split('-')[1]
      : selectedYear
  };
};
